import { useQueries, UseQueryOptions } from '@tanstack/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { bzAxios } from 'Lib/bzAxios'
import { TagsResponse } from 'Types/TagsResponse'

type BzDetailsResponse = {
  active: boolean
  application: number
  dataLocationRegion: number
  id: number
  name: string
  secretKey: string
  tags: null
  timezone: string
}

export const useGetBzDetails = () => {
  const { networkId } = useUserStore()

  return useQueries({
    queries: [
      {
        queryKey: ['bzDetails'],
        queryFn: () => getBzDetails(networkId),
      } as UseQueryOptions<BzDetailsResponse | Error>,

      {
        queryKey: ['tags'],
        queryFn: () => getTags(networkId),
      } as UseQueryOptions<TagsResponse | Error>,
    ],
  })
}

const getBzDetails = (networkId: string): Promise<BzDetailsResponse | Error> => {
  return bzAxios
    .get<BzDetailsResponse>(`/?networkIdEnc=${networkId}`)
    .then((res) => {
      return res.data
    })
    .catch((e) => {
      return e as Error
    })
}

const getTags = (networkId: string): Promise<TagsResponse | Error> => {
  return bzAxios
    .get<TagsResponse>(`/tags?networkIdEnc=${networkId}`)
    .then((res) => {
      return res.data
    })
    .catch((e) => {
      return e as Error
    })
}
